/* copy: internal — the buy path of the Liverty sales page, the mechanics of snippets/lv_house_sel.liquid (theme 152576196775) carried onto the
   Healora-layout package cards (2026-09-24). One-time: variant 51311091843239 at qty 1 / 3 / 5, the automatic BXGY discounts make the free
   bottles free. Subscribe: variant 45439894749351 on the Seal plan at qty 1 / 2 / 3 plus a one-time line of the free bottles, which the
   subscribe BXGY discounts make free in the first box only. Proof: liverty/launches/offer-bxgy-20260922/verify_ladder.py + verify_sub.py. */
(function () {
  function active(pkg) { return pkg.querySelector('.purchase-box-inner.active') || pkg.querySelector('.purchase-box-inner'); }
  function money(s) { return parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0; }
  function cap(ev, props) { try { if (window.posthog) posthog.capture(ev, props); } catch (e) {} }
  function nativeFallback(items) {
    /* Shopify can answer the XHR with an HTML bot-challenge page; a navigation passes the challenge, a fetch cannot. */
    var f = document.createElement('form'); f.method = 'post'; f.action = '/cart/add'; f.style.display = 'none';
    items.forEach(function (it, i) {
      Object.keys(it).forEach(function (k) {
        var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'items[' + i + '][' + k + ']'; inp.value = it[k]; f.appendChild(inp);
      });
    });
    var rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; rt.value = '/checkout'; f.appendChild(rt);
    document.body.appendChild(f); f.submit();
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('a.package_btn'); if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.dataset.busy) return; btn.dataset.busy = '1';
    var pkg = btn.closest('.package'); var box = active(pkg); var d = box.dataset;
    var sub = d.mode === 'subscribe';
    var line = { id: parseInt(d.variant, 10), quantity: parseInt(d.qty || '1', 10) };
    if (sub && d.plan) line.selling_plan = parseInt(d.plan, 10);
    var items = [line];
    var gift = parseInt(d.giftQty || '0', 10);
    if (sub && gift > 0 && d.giftId) items.push({ id: parseInt(d.giftId, 10), quantity: gift });
    var tierEl = pkg.querySelector('.pkage_heading');
    var props = { offer: 'liverty', page_type: 'pdp', variant_id: String(line.id), quantity: line.quantity, value: money(d.each), currency: 'USD',
                  purchase_type: sub ? 'subscription' : 'one_time', tier: tierEl ? tierEl.textContent.trim() : '', page: location.pathname };
    var old = document.getElementById('lv-cart-error'); if (old) old.remove();
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.json(); })
      .then(function () {
        cap('add_to_cart', props); cap('checkout_started', props);
        try { if (window.pfxTrack) window.pfxTrack('AddToCart'); } catch (e) {}
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.dataset.busy = '';
        cap('add_to_cart_failed', Object.assign({ status: String(err && err.message || '') }, props));
        try { if (window.posthog && posthog.captureException) posthog.captureException(err, Object.assign({ funnel_failure: true }, props)); } catch (e) {}
        nativeFallback(items);
      });
  }, true);
})();
